import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

const FloatingDonate = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={() => scrollToSection('donate')}
      className={`fixed bottom-24 md:bottom-28 right-4 md:right-8 w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#FF6B6B] to-[#EE5A5A] rounded-full shadow-2xl flex items-center justify-center text-white font-semibold transition-all duration-300 hover:scale-110 z-50 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20 pointer-events-none'
      }`}
    >
      <div className="text-center">
        <Heart className="w-5 h-5 md:w-6 md:h-6 mb-1 fill-white mx-auto" />
        <span className="text-[9px] md:text-[10px] uppercase tracking-wider">Donate</span>
      </div>
    </button>
  );
};

export default FloatingDonate;